(() => {
  if (customElements.get('ml-bf-grid')) return;
  customElements.define('ml-bf-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const track = this.querySelector('.ml-bf-product-pages');
      const pages = [...track.children];
      const prev = this.querySelector('[data-bf-prev]');
      const next = this.querySelector('[data-bf-next]');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const index = () => pages.reduce((best, page, i) => Math.abs(page.getBoundingClientRect().left - track.getBoundingClientRect().left) < Math.abs(pages[best].getBoundingClientRect().left - track.getBoundingClientRect().left) ? i : best, 0);
      const update = () => {
        const i = index();
        this.querySelector('[data-bf-current]').textContent = i + 1;
        this.querySelector('[data-bf-total]').textContent = pages.length;
        prev.disabled = i === 0;
        next.disabled = i === pages.length - 1;
      };
      const move = delta => {
        const i = Math.max(0, Math.min(pages.length - 1, index() + delta));
        track.scrollBy({ left: pages[i].getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
    }
  });
})();
